import { Eye, MessageSquarePlus } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { ExcerptusPrompt } from "@/lib/composerPrompts";

type Props = {
  prompt: ExcerptusPrompt | null;
  onOpenChange: (open: boolean) => void;
};

export const PromptPreviewDialog = ({ prompt, onOpenChange }: Props) => (
  <Dialog open={Boolean(prompt)} onOpenChange={(o) => !o && onOpenChange(false)}>
    <DialogContent className="max-w-2xl">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Eye className="h-4 w-4" /> Preview as user
        </DialogTitle>
        <DialogDescription>
          This is exactly how this prompt appears to a user in the Prompts panel.
        </DialogDescription>
      </DialogHeader>
      {prompt && (
        <div className="space-y-3">
          <div>
            <h3 className="text-base font-semibold">{prompt.title}</h3>
            {(prompt.tags?.length || prompt.model_hint) && (
              <div className="mt-1 flex flex-wrap gap-1">
                {prompt.model_hint && (
                  <Badge variant="secondary" className="text-[10px]">{prompt.model_hint}</Badge>
                )}
                {(prompt.tags ?? []).map((t) => (
                  <Badge key={t} variant="secondary" className="text-[10px]">{t}</Badge>
                ))}
              </div>
            )}
          </div>
          <pre className="max-h-[50vh] overflow-auto whitespace-pre-wrap rounded-md border bg-muted/40 p-3 font-mono text-xs">
{prompt.body}
          </pre>
          <div className="flex justify-end">
            <Button size="sm" disabled title="Disabled in preview">
              <MessageSquarePlus className="h-3.5 w-3.5" /> Push to Chat
            </Button>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
